import { usePermissions } from "@/hooks/usePermissions";
import { ShieldAlert } from "lucide-react";

export function AccessDenied() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4 text-center px-4">
      <div className="h-16 w-16 rounded-2xl bg-muted flex items-center justify-center">
        <ShieldAlert className="h-8 w-8 text-muted-foreground" />
      </div>
      <h2 className="text-xl font-semibold">Acesso restrito</h2>
      <p className="text-sm text-muted-foreground max-w-sm">
        Você não tem permissão para acessar esta página.
        Entre em contato com o administrador para solicitar acesso.
      </p>
    </div>
  );
}

export function PermissionGuard({
  permission,
  children,
  fallback,
}: {
  permission: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  const { can } = usePermissions();

  if (!can(permission)) {
    return <>{fallback ?? <AccessDenied />}</>;
  }

  return <>{children}</>;
}

export function MaskedField({
  value,
  permission,
}: {
  value: string | null | undefined;
  permission: string;
}) {
  const { can } = usePermissions();

  if (!value) return <span className="text-muted-foreground">-</span>;

  if (can(permission)) return <span>{value}</span>;

  // Mascarar o valor
  if (permission === "data:phone_visible") {
    const masked = value.length > 6
      ? value.slice(0, 4) + "****" + value.slice(-2)
      : "****";
    return <span className="text-muted-foreground">{masked}</span>;
  }

  if (permission === "data:email_visible") {
    const [local, domain] = value.split("@");
    const masked = domain ? `${local[0]}***@${domain}` : "****";
    return <span className="text-muted-foreground">{masked}</span>;
  }

  return <span className="text-muted-foreground">****</span>;
}
